/**
 * Find value by prefiw
 * @param object
 * @param prefix
 * @returns {*}
 */
export function findValueByPrefix(i__object, i__prefix) {
    for (let property in i__object) {
        if (i__object.hasOwnProperty(property) &&
            property.toString().startsWith(i__prefix)) {
            return i__object[property];
        }
    }
}